import { ChakraProvider } from '@chakra-ui/react';
import createCache from '@emotion/cache';
import { CacheProvider, ThemeProvider as EmotionThemeProvider, Global } from '@emotion/react';
import * as React from 'react';
import { GlobalStyles } from './GlobalStyles';
import { GlobalFontStyles } from './fonts/GlobalFontStyles';
import { getTheme } from './theme';

const cache = createCache({
  key: 'txt',
  // disable the vendor prefixes in development for better readability
  ...(process.env.NODE_ENV === 'development' && { stylisPlugins: [] }),
});

export const TxtureThemeProvider: React.FC<{ useMyNavStyling?: boolean; children: React.ReactNode }> = ({
  useMyNavStyling = false,
  children,
}) => {
  const theme = getTheme(useMyNavStyling);

  return (
    <CacheProvider value={cache}>
      <EmotionThemeProvider theme={theme}>
        <ChakraProvider value={theme}>
          <LegacyCssVariables />
          <GlobalFontStyles />
          <GlobalStyles />
          {children}
        </ChakraProvider>
      </EmotionThemeProvider>
    </CacheProvider>
  );
};

const LegacyCssVariables = () => (
  <Global
    styles={(theme) => `
        body {
          --colors-primary-50: ${theme.token('colors.primary.50')};
          --colors-primary-200: ${theme.token('colors.primary.200')};
          --colors-primary-300: ${theme.token('colors.primary.300')};
          --colors-primary-500: ${theme.token('colors.primary.500')};
          --colors-primary-600: ${theme.token('colors.primary.600')};

          --colors-text: ${theme.token('colors.text')};
          --colors-blue: ${theme.token('colors.blue.500')};

          --colors-grey-50: ${theme.token('colors.grey.50')};
          --colors-grey-100: ${theme.token('colors.grey.100')};
          --colors-grey-200: ${theme.token('colors.grey.200')};
          --colors-grey-300: ${theme.token('colors.grey.300')};
          --colors-grey-500: ${theme.token('colors.grey.500')};

          --colors-error: ${theme.token('colors.status.error.main')};
          --colors-warning: ${theme.token('colors.status.warning.main')};
          --colors-action-focus: ${theme.token('colors.primary.50')};
          --colors-action-disabled: ${theme.token('colors.grey.200')};

          --portal-zIndex: ${theme.token('zIndex.portal')};

          --card-bg: ${theme.token('colors.card.background')};
          --shadows-floating: ${theme.token('shadows.floating')};
        }
  `}
  />
);
